import { GoalStatusEnum, type Goal } from "@features/api/TrackerApi";

/** Plan For You — Next step todo（design §4.8.1 · AC-2.1） */
export function filterPlanInactiveTodos(goals: Goal[]): Goal[] {
  return goals.filter((goal) => goal.status === GoalStatusEnum.INACTIVE);
}

/** Pending is broader than the existing For You todo list: refined plans stay actionable. */
export function filterPlanPendingGoals(goals: Goal[]): Goal[] {
  return goals.filter(
    (goal) =>
      goal.status === GoalStatusEnum.INACTIVE ||
      goal.status === GoalStatusEnum.PLANNED,
  );
}
